import { ComplianceCaseTypeEnum } from "../../../graphql/supergraphEnums";
import { Programs } from "../../../utils/compliance_program";
import {
  RuleEntry,
  StatusKeys,
  ShowDetailsKey,
  CompletionDetailsKey,
  OwnersKey,
  ControllersKey,
  ProfileCategory,
} from "./types";

export const PROFILE_STATUS_RULES_MATRIX: (RuleEntry & StatusKeys)[] = [
  // --- SUBSCRIPTION ---
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: true,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: false,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.JOINT,
    isRoot: true,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.JOINT,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: true,
    detailsKey: ShowDetailsKey.SURVEY_COUNT,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.YES,
    controllersKey: ControllersKey.YES,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.RELATIONSHIP_CRITERIA,
    controllersKey: ControllersKey.RELATIONSHIP_CRITERIA,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: true,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.JOINT,
    isRoot: true,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.JOINT,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: true,
    detailsKey: ShowDetailsKey.SURVEY_COUNT,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.YES,
    controllersKey: ControllersKey.YES,
  },
  {
    context: ComplianceCaseTypeEnum.InvestorOnboarding,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.RELATIONSHIP_CRITERIA,
    controllersKey: ControllersKey.RELATIONSHIP_CRITERIA_AML,
  },
  // --- REMEDIATION ---
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: false,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.JOINT,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [
      CompletionDetailsKey.LEGAL_NAME,
      CompletionDetailsKey.AML_ENTITY_TYPE_ID,
    ],
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.JOINT,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.YES,
    controllersKey: ControllersKey.YES,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.KYC],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.RELATIONSHIP_CRITERIA,
    controllersKey: ControllersKey.RELATIONSHIP_CRITERIA,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    // Special case for the joint individual profile
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.KYC, Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.JOINT_INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.JOINT,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [
      CompletionDetailsKey.LEGAL_NAME,
      CompletionDetailsKey.AML_ENTITY_TYPE_ID,
    ],
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.JOINT,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.YES,
    controllersKey: ControllersKey.YES,
  },
  {
    context: ComplianceCaseTypeEnum.Remediation,
    programType: [Programs.US_AML, Programs.CAYMANS_AML],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.RELATIONSHIP_CRITERIA,
    controllersKey: ControllersKey.RELATIONSHIP_CRITERIA_AML,
  },
  // --- Profile refresh ---
  {
    context: ComplianceCaseTypeEnum.ProfileRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.ProfileRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    // Special case for the joint individual profile
    context: ComplianceCaseTypeEnum.ProfileRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.JOINT_INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.DATE_OF_BIRTH],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.ProfileRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.JOINT,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [
      CompletionDetailsKey.LEGAL_NAME,
      CompletionDetailsKey.AML_ENTITY_TYPE_ID,
    ],
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.ProfileRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.JOINT,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.JOINT_MIN_TWO_CHILDREN,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.ProfileRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: true,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.YES,
    controllersKey: ControllersKey.YES,
  },
  {
    context: ComplianceCaseTypeEnum.ProfileRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: false,
    detailsKey: ShowDetailsKey.YES,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.RELATIONSHIP_CRITERIA,
    controllersKey: ControllersKey.RELATIONSHIP_CRITERIA_AML,
  },
  // --- Document refresh ---
  {
    context: ComplianceCaseTypeEnum.DocumentRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: true,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.DocumentRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    // Special case for the joint individual profile
    context: ComplianceCaseTypeEnum.DocumentRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.JOINT_INDIVIDUAL,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.DocumentRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.JOINT,
    isRoot: true,
    detailsKey: ShowDetailsKey.AML_ENTITY_ID,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: false,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.DocumentRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.JOINT,
    isRoot: false,
    detailsKey: ShowDetailsKey.NO,
    detailsCompletionKey: null,
    documentsStatus: false,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.DocumentRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: true,
    detailsKey: ShowDetailsKey.AML_ENTITY_ID,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
  {
    context: ComplianceCaseTypeEnum.DocumentRefresh,
    programType: [Programs.NONE],
    profileCategory: ProfileCategory.ENTITY,
    isRoot: false,
    detailsKey: ShowDetailsKey.AML_ENTITY_ID,
    detailsCompletionKey: [CompletionDetailsKey.AML_ENTITY_TYPE_ID],
    documentsStatus: true,
    ownersKey: OwnersKey.NO,
    controllersKey: ControllersKey.NO,
  },
];
